// @flow
/** @jsx h */
import { Component, h } from 'preact';
import Content from './Content';
import Helmet from 'preact-helmet';
import type { BicContentType } from '../../modelType/bicType';
import withTerminalApiResponse from '../../HOC/withTerminalApiResponse';
import { tracker, UserActionType } from '../../tracking';
import style from './style.css';
import { getLocalstorage, setLocalStorage } from '../../utils';
import { connect } from 'react-redux';
import Categories from './categories';

type State = {
  showAddToHomeScreenPrompt: boolean,
  shouldOpenEligiblePanel: boolean,
};
type Props = {
  uiComponents: Array<BicContentType>,
  pageKey: string,
  bicAction: Function,
  showShowLenderList: boolean,
  getLenderList: Array<LenderDetails>,
  ntbDetails: Object,
  apiState: boolean,
  message: string,
  userStatus: string,
  showEligibilityModal: boolean,
};
let checkAddToHomeScreenPrompt;
class BicContainer extends Component<Props, State> {
  displayComponentName = 'SHOW_USER_ELIGIBLE';
  state = {
    showAddToHomeScreenPrompt: false,
    shouldOpenEligiblePanel: this.props.uiComponents.includes(
      this.displayComponentName,
    ),
  };
  componentDidMount() {
    this.detectAddToHomeScreenPrompt();
  }
  componentDidUpdate(previousProps) {
    //for existing user hiding the panel after 3 sec
    if (
      this.props.uiComponents.includes(this.displayComponentName) !==
      previousProps.uiComponents.includes(this.displayComponentName)
    ) {
      setTimeout(() => {
        this.setState({
          shouldOpenEligiblePanel: this.props.uiComponents.includes(
            this.displayComponentName,
          ),
        });
      }, 3000);
    }
  }
  detectAddToHomeScreenPrompt = () => {
    let promptDetectCounter = 1;
    checkAddToHomeScreenPrompt = setInterval(() => {
      if (window.addToHomeScreenObject && window.addToHomeScreenObject.prompt) {
        this.triggerAddToHomeScreenPrompt();
        clearInterval(checkAddToHomeScreenPrompt);
      }
      if (promptDetectCounter === 30) {
        // Killing the Interval if no prompt detected for 15 secs
        clearInterval(checkAddToHomeScreenPrompt);
      } else {
        promptDetectCounter++;
      }
    }, 500); // Checking if prompt is detected every 500 milliseconds
  };
  triggerAddToHomeScreenPrompt = () => {
    const hidePrompt = getLocalstorage('hideAddToHomeScreenPrompt') || '';
    const { prompt } = window.addToHomeScreenObject || {};
    const shouldAskForAddToHome = prompt && !(hidePrompt === 'true');
    if (shouldAskForAddToHome) {
      setTimeout(() => {
        this.setState({
          showAddToHomeScreenPrompt: true,
          shouldOpenEligiblePanel: false,
        });
      }, 3000);
    }
  };
  onHideAddToScreenCallBack = () => {
    tracker.trackUserInteraction(
      UserActionType.CLICK,
      'NOT NOW',
      this.props.pageKey,
    );
    setLocalStorage('hideAddToHomeScreenPrompt', 'true');
    this.setState({
      showAddToHomeScreenPrompt: false,
    });
  };
  hideEligiblePanel = (shouldHide) => {
    this.setState({
      shouldOpenEligiblePanel: !shouldHide,
    });
  };
  render() {
    const { showAddToHomeScreenPrompt, shouldOpenEligiblePanel } =
      this.state || {};
    return (
      <div className={style.bicContainer}>
        <Helmet
          title='InstaCred Cardless EMI. Shop on EMI without credit card. Buy Now Pay Later'
          meta={[
            {
              name: 'description',
              content:
                'EMI on mobiles, laptops, electronics, fashion, furnishing & more. Shop with InstaCred Cardless EMI, Flipkart EMI, Amazon EMI, IDFC EMI, HDFC EMI, ICICI EMI, Kotak EMI',
            },
          ]}
          link={[
            {
              rel: 'canonical',
              href: 'https://instacred.me/buy',
            },
          ]}
        />
        {this.props.message && (
          <div className={style.errorMessageContainer}>
            {this.props.message}
          </div>
        )}

        <Categories
          pageKey={this.props.pageKey}
          header='Category'
          bicAction={this.props.bicAction}
        />
        {this.props.uiComponents.map((contentType, i) => {
          return (
            <Content
              contentType={contentType}
              pageKey={this.props.pageKey}
              bicAction={this.props.bicAction}
              hideEligiblePanel={this.hideEligiblePanel}
              matches={this.props.matches}
            />
          );
        })}
        <div style={{ display: 'none' }}>
          <div>
            online shopping, flipkart, flipkart online shopping, emi, cardless
            emi, emi without credit card, flipkart mobile, flipkart in india,
            flipkart offers, flipkart online, flipkart sale, flipkart big
            billion days, big billion days 2021, flipkart shoes, InstaCred
            Cardless Emi, coupon codes,
          </div>
          <div>
            online shopping, amazon, amazon india, amazon shopping, amazon
            offers, amazon sale, amazon mobile, emi, cardless emi, emi without
            credit card, amazon online shopping, amazon promo code, amazon india
            sale, great indian festival, amazon great india festival 2021 sale,
            coupon codes
          </div>
          <div>
            online shopping, myntra, myntra sale, myntra coupons, myntra offers,
            myntra shopping, myntra online, shop, online shop, clothing shop
            online, myntra clothing, myntra dresses for women, dresses online,
            womens clothes, myntra dresses, emi, emi without credit card,
            InstaCred Cardless EMI, Decathlon, Decathlon online, Decathlon
            online shopping, Decathlon India, Decathlon shoes, Decathlon store,
            Decathlons,
          </div>
          <div>
            Online shopping, offers, sale, coupon codes, online shopping sites,
            Sangeetha Mobiles, offers in sangeetha mobiles, vijay sales,
            electronic stores, vijay Sales laptops, Poorvika Mobiles,
            poorvikamobile, M D Computers, Dell, dell laptops, computer
            accessories, desktop processor, AMD Ryzen, NVIDA, graphics card,
            gaming mouse, 8gb ddr4 ram, ddr4 ram, 8gb ram, ram 16gb, memory for
            computer, md computers, Samsung mobiles, s21 ultra, Samsung galaxy,
            mobile phones, mobiles on emi, Xiaomi, Redmi, Redmi note 9 pro,
            Redmi note 9, Vivo, Vivo y20, Vivo v20, Vivo mobiles
          </div>
          <div>
            emi, cardless emi, emi without credit card, mobiles, mobile phone,
            mobile accessories, readmi, realme, vivo, oppo, i phone, rog3,
            samsung mobiles, electronic stores, electronics, dell laptops, dell
            inspiron, coupon codes, online shopping sites
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({ ntbConfig }) => {
  const {
    getLenderList,
    apiState,
    showShowLenderList,
    ntbDetails,
    message,
    userStatus,
    showEligibilityModal,
  } = ntbConfig;
  return {
    apiState,
    showShowLenderList,
    getLenderList,
    ntbDetails,
    message,
    userStatus,
    showEligibilityModal,
  };
};
export default withTerminalApiResponse(connect(mapStateToProps)(BicContainer));



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/bicContainer.js